export default __webpack_public_path__ + "static/media/talksig-wheel.8628866b.png";